<script lang="ts" setup>
import { useId } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { provide } from 'vue';

import { cn } from '@/shared/lib/misc';

import { FORM_ITEM_INJECTION_KEY } from './injection-keys';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();

const id = useId();
provide(FORM_ITEM_INJECTION_KEY, id);
</script>

<template>
  <div data-slot="form-item" :class="cn('flex flex-col gap-2', props.class)">
    <slot />
  </div>
</template>
